const loadImg = (src) => new Promise((r) => { const i = new Image(); i.onload = () => r(i); i.onerror = () => r(null); i.src = src; });

const round = (x, X, Y, w, h, r) => { x.beginPath(); x.roundRect(X, Y, w, h, r); };

export const shareLink = (code) => `${window.location.origin}/?ref=${code}`;

export const shareText = (d, code, name) => {
  const link = shareLink(code);
  return d.total_kg > 0
    ? `${name ? `${name} here! ` : ""}I've recycled ${d.total_kg} kg of scrap with Kindsaver and got paid for it at my door. That's ~${d.co2_kg} kg CO2 kept out of the air and ${d.trees} trees saved.\n\nYour old newspapers, cartons and bottles are worth money too. Book a free doorstep pickup with my code *${code}*:\n${link}`
    : `I just joined Kindsaver: free doorstep scrap pickup in Jaipur, fair live rates, paid on the spot, and everything gets recycled.\n\nJoin with my code *${code}*:\n${link}`;
};

const fit = (x, text, font, size, max) => {
  let s = size;
  do { x.font = `${font.replace("%", s)}`; s -= 4; } while (x.measureText(text).width > max && s > 30);
};
const center = (x, text, y) => x.fillText(text, (1080 - x.measureText(text).width) / 2, y);
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "");

export const drawImpact = async (d, code) => {
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1350;
  const x = c.getContext("2d");
  const cert = d.certificate || {};
  await Promise.all(["700 70px Fraunces", "800 40px Outfit", "600 30px 'Plus Jakarta Sans'"].map((f) => document.fonts?.load(f).catch(() => {})));
  x.fillStyle = "#FBF8EF"; x.fillRect(0, 0, 1080, 1350);
  x.globalAlpha = 0.08; x.fillStyle = "#2E9E6B";
  x.beginPath(); x.arc(1000, 90, 300, 0, Math.PI * 2); x.fill(); x.beginPath(); x.arc(70, 1280, 260, 0, Math.PI * 2); x.fill();
  x.globalAlpha = 1;
  x.strokeStyle = "#0D3B2B"; x.lineWidth = 18; x.strokeRect(30, 30, 1020, 1290);
  x.strokeStyle = "#2E9E6B"; x.lineWidth = 3; x.strokeRect(62, 62, 956, 1226);
  const logo = await loadImg("/logo-full.png");
  if (logo) x.drawImage(logo, 340, 110, 400, 400 * (logo.height / logo.width));
  x.fillStyle = "#2E9E6B"; x.font = "800 28px Outfit, sans-serif";
  center(x, "C E R T I F I C A T E   O F   G R E E N   I M P A C T", 270);
  x.fillStyle = "#4A6358"; x.font = "600 30px 'Plus Jakarta Sans', sans-serif"; center(x, "This certifies that", 345);
  x.fillStyle = "#0D3B2B"; fit(x, cert.name || "Kindsaver member", "700 %px Fraunces, Georgia, serif", 86, 880); center(x, cert.name || "Kindsaver member", 440);
  x.fillStyle = "#4A6358"; x.font = "600 28px 'Plus Jakarta Sans', sans-serif";
  center(x, [cert.customer_type, cert.area, cert.member_since && `member since ${fmt(cert.member_since)}`].filter(Boolean).join("  ·  "), 495);
  x.fillStyle = "#4A6358"; x.font = "600 30px 'Plus Jakarta Sans', sans-serif";
  center(x, d.total_kg > 0 ? "has recycled with Kindsaver" : "has joined the Kindsaver green movement", 575);
  x.fillStyle = "#0D3B2B"; x.font = "800 170px Outfit, sans-serif";
  const big = `${d.total_kg}`; const bw = x.measureText(big).width; x.font = "800 70px Outfit, sans-serif"; const kw = x.measureText(" kg").width;
  const sx = (1080 - bw - kw) / 2;
  x.font = "800 170px Outfit, sans-serif"; x.fillText(big, sx, 745); x.font = "800 70px Outfit, sans-serif"; x.fillStyle = "#2E9E6B"; x.fillText(" kg", sx + bw, 745);
  const stats = [[`${d.co2_kg} kg`, "CO₂ avoided"], [`${d.trees}`, "trees saved"], [`${d.completed}`, "pickups"], [cert.rank ? `#${cert.rank}` : "—", cert.of ? `of ${cert.of} recyclers` : "rank"]];
  stats.forEach(([v, l], i) => {
    const X = 110 + i * 220;
    x.fillStyle = "#fff"; round(x, X, 800, 200, 150, 26); x.fill(); x.strokeStyle = "#DCE8E0"; x.lineWidth = 2; x.stroke();
    x.fillStyle = "#0D3B2B"; fit(x, v, "800 %px Outfit, sans-serif", 52, 170); x.fillText(v, X + (200 - x.measureText(v).width) / 2, 875);
    x.fillStyle = "#4A6358"; x.font = "600 22px 'Plus Jakarta Sans', sans-serif"; x.fillText(l, X + (200 - x.measureText(l).width) / 2, 915);
  });
  const top = Object.entries(d.by_type || {}).sort((a, b) => b[1] - a[1]).slice(0, 3).map(([k, v]) => `${k} ${v} kg`).join("  ·  ");
  if (top) { x.fillStyle = "#2E9E6B"; x.font = "700 26px 'Plus Jakarta Sans', sans-serif"; center(x, top, 1000); }
  x.fillStyle = "#E05C3A"; round(x, 140, 1040, 800, 150, 32); x.fill();
  x.setLineDash([12, 9]); x.strokeStyle = "rgba(255,255,255,.75)"; x.lineWidth = 3; round(x, 156, 1056, 768, 118, 24); x.stroke(); x.setLineDash([]);
  x.fillStyle = "#fff"; x.font = "700 24px 'Plus Jakarta Sans', sans-serif"; center(x, "FREE DOORSTEP PICKUP IN JAIPUR · USE MY CODE", 1098);
  x.font = "800 64px Outfit, sans-serif"; center(x, code || "", 1162);
  x.fillStyle = "#4A6358"; x.font = "600 22px 'Plus Jakarta Sans', sans-serif";
  x.fillText(`Certificate no. ${cert.no || "—"}`, 100, 1240); const iss = `Issued ${fmt(new Date().toISOString())}`; x.fillText(iss, 980 - x.measureText(iss).width, 1240);
  center(x, shareLink(code).replace(/^https?:\/\//, ""), 1272);
  return new Promise((r) => c.toBlob(r, "image/png"));
};
